import React from "react";
import Hero from "../components/Hero";
import StatsStrip from "../components/StatsStrip";
import MainlandFreezone from "../components/MainlandFreezone";
import ServicesGrid from "../components/ServicesGrid";
import FreezonesGrid from "../components/FreezonesGrid";
import IndustriesGrid from "../components/IndustriesGrid";
import ProcessTimeline from "../components/ProcessTimeline";
import VisaServicesSection from "../components/VisaServicesSection";
import BankingSection from "../components/BankingSection";
import WhyStartINC from "../components/WhyStartINC";
import Testimonials from "../components/Testimonials";
import FAQSection from "../components/FAQSection";
import ConsultationCTASection from "../components/ConsultationCTASection";

export default function HomePage() {
  return (
    <div data-testid="home-page">
      <Hero />
      <StatsStrip />
      <MainlandFreezone />
      <ServicesGrid />
      <FreezonesGrid />
      <ProcessTimeline />
      <VisaServicesSection />
      <BankingSection />
      <IndustriesGrid />
      <WhyStartINC />
      <Testimonials />
      <FAQSection />
      <ConsultationCTASection />
    </div>
  );
}
